import { RootState } from "..";

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Workspace } from "../../api";
import {
  Integration,
  IntegrationSchema,
  getWorkspaceIntegrations,
} from "../../api/integrations";

export enum IntegrationsStateStatus {
  LOADING,
  LOADED,
  FAILED,
}

export interface IntegrationsState {
  status: IntegrationsStateStatus;
  schema: IntegrationSchema[];
  integrations: Integration[];
}

export const loadIntegrations = createAsyncThunk<
  { schema: IntegrationSchema[]; integrations: Integration[] },
  { workspace: Workspace },
  { state: RootState }
>("integrations/loadIntegrations", async (data, { rejectWithValue }) => {
  try {
    return await getWorkspaceIntegrations(data.workspace.id);
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const integrationsSlice = createSlice({
  name: "integrations",
  initialState: {
    status: IntegrationsStateStatus.LOADING,
    schema: [],
    integrations: [],
  } as IntegrationsState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadIntegrations.pending, (state) => {
      state.status = IntegrationsStateStatus.LOADING;
    });
    builder.addCase(loadIntegrations.fulfilled, (state, action) => {
      state.status = IntegrationsStateStatus.LOADED;
      state.schema = action.payload.schema;
      state.integrations = action.payload.integrations;
    });
    builder.addCase(loadIntegrations.rejected, (state) => {
      state.status = IntegrationsStateStatus.FAILED;
      state.schema = [];
      state.integrations = [];
    });
  },
});

export default integrationsSlice.reducer;
